/** Shown on stat pages before a season has produced any results. */
export function NoGamesYet({ season }: { season: number }) {
  return (
    <div className="card mt-6 flex flex-col items-center gap-2 px-6 py-16 text-center">
      <p className="font-display text-xl font-bold">The {season} season hasn't kicked off.</p>
      <p className="max-w-md text-sm text-chalk-dim">
        No games have been played yet. Standings, points, and the rest fill in
        once Week 1 is in the books.
      </p>
    </div>
  );
}
